import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    shortDescription: null,
    validationError: null
};

const validate = state => ({
    ...state,
    validationError:
        state.shortDescription && state.shortDescription.trim() !== ''
            ? null
            : 'syi_validation_missing_title'
});

const shortDescriptionSlice = createSlice({
    name: 'shortDescription',
    initialState,
    reducers: {
        setShortDescription: (state, action) =>
            validate({ ...state, shortDescription: action.payload }),
        resetShortDescription: state =>
            validate({ ...state, shortDescription: null })
    }
});

export const {
    setShortDescription,
    resetShortDescription
} = shortDescriptionSlice.actions;

export default shortDescriptionSlice.reducer;
